import I18n from "@vocollege/app/dist/modules/Services/I18n";
import { GeneralObject } from "@vocollege/app/dist/global";

export const getOptionValues = (key: string, data: any) => {
  if (!(key in data)) {
    return [];
  }
  let result = data[key].map((v: string) => {
    let option = I18n.get.application[key].find(
      (o: GeneralObject) => o.name === v,
    );
    return option?.label;
  });
  return result;
};

export const getCertItems = (data: any) => {
  if (!data) {
    return [];
  }
  return data.map((v: string) => {
    let item = I18n.get.application.certItems.find(
      (item: any) => item.name === v,
    );
    return item ? item.label : "";
  });

  // let result = data.map((v: string) => {
  //   return I18n.get[v].label;
  // });
  // return result;
};
// export const getCertItems = (data: any) => {
//   let result = data.map((v: string) => {
//     return I18n.get[v].label;
//   });
//   return result;
// };
